import { useState, useEffect, useCallback } from 'react';
import useQueryServices from './useQueryServices';
import Functions from '../api/Functions';
import { getRandomCode } from '../utils/CodeUtil';
import { profileFields, signUpStatus } from '../constants/constants';

const useInviteCodeServices = () => {
  const { documents: profiles, addToFilters, loadFilteredDocuments } = useQueryServices('profiles', 'email');

  const [loading, setLoading] = useState(false);
  const [emailErrorMessages, setEmailErrorMessages] = useState([]);
  const [numberOfInviteCodeSent, setNumberOfInviteCodeSent] = useState(0);

  useEffect(
    () => {
      // make a query to get all profiles on the waiting list
      addToFilters(profileFields.SIGN_UP_STATUS, '==', signUpStatus.ON_WAITING_LIST);
      loadFilteredDocuments(false);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  const haveGeneratedCodeNotBeenUsed = async (code) => {
    try {
      const { data: codeHaveNotBeenUsed } = await Functions.inviteCodeExists(code);
      return codeHaveNotBeenUsed;
    } catch (error) {
      throw new Error(`From inviteCodeExists function: ${error}`);
    }
  };

  const generateInviteCode = () => {
    let inviteCodeGenerated;

    while (true) {
      inviteCodeGenerated = getRandomCode();

      try {
        // check if it doesn't already exists in inviteCode collection
        if (haveGeneratedCodeNotBeenUsed(inviteCodeGenerated)) {
          break;
        }
      } catch (error) {
        throw error;
      }
    }

    return inviteCodeGenerated;
  };

  const sendInviteCodeToAllProfiles = useCallback(
    async () => {
      let numberOfCodeSent = 0;
      let errorMessages = [];
      setLoading(true);

      for (const profile of profiles) {
        try {
          let inviteCode = generateInviteCode();
          numberOfCodeSent++;

          const {
            data: { sendEmailError },
          } = await Functions.sendInviteCodeToUser(profile.id, profile.email, inviteCode);

          if (sendEmailError) {
            errorMessages.push(`Unable to send an invite code to ${profile.email}`);
            numberOfCodeSent--;
          }
        } catch (error) {
          errorMessages.push(`Error occur when sending invite code to all waitlisted profiles: ${error}`);
          console.error(error);
        }
      }

      if (errorMessages.length) {
        setEmailErrorMessages(errorMessages);
      }

      setNumberOfInviteCodeSent(numberOfCodeSent);
      setLoading(false);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [profiles],
  );

  return {
    loading,
    emailErrorMessages,
    numberOfInviteCodeSent,
    sendInviteCodeToAllProfiles,
  };
};

export default useInviteCodeServices;
